<template>
	<div>
	<header class="mdc-top-app-bar top-app-bar top-header">
		<div class="mdc-top-app-bar__row">
			<section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start">
				<!-- <button class="material-icons mdc-top-app-bar__navigation-icon mdc-icon-button hide-desktop navToggle"
					aria-label="Open navigation menu">menu</button> -->
				<span class="mdc-top-app-bar__title t-subtitle4 pdl-12 cursor-pointer">{{title}}</span>
			</section>
			<section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end" role="toolbar">
				<!-- <div class="profile d-flex align-items-center mgr-24"><img src="images/avtar.svg"
						class="w-32 h-32 circle mgr-16" alt="">
					<div class="t-body2 t-color-white">USER ID</div>
				</div> -->
				<div class=" t-body2 t-color-white pdr-18 cursor-pointer" @click="login" @keypress="login" tabindex="0">{{$t('3323')}}</div>
				<!-- <div class=" t-body2 t-color-appbarText pdr-18 cursor-pointer">LOGOUT</div> -->
			</section>
		</div>
	</header>
	<div class="d-flex h-full flex-column">
		<main class="main-wrapper full flex-grow-1 scroll-y">
			<div class="container container--small pdt-30 ">
				<form @submit.prevent="next()" novalidate>
				<div class="pdl-24 pdr-24">
					<div class="t-headline11 font-m mgt-20 mgb-8">{{$t('794')}}</div>
					<div class=" ">
						<span class="t-color-bodyGrayA font-r">{{$t('1550').slice(0,-1)}}</span>
						<span class="body1 font-r t-subtitle2">{{' '+memberDutyName}} </span> <span class="t-color-bodyGrayA"> and </span>  <span class="body1 font-r t-subtitle2">{{ memberResponsibilityName}}</span>
					</div>
					<div class="mgt-40 mgb-28">
						<label
							class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full customize-input h-46 "
							data-mdc-auto-init="MDCTextField"
							:class="submitState && codeInvalidCheck ? 'mdc-text-field--invalid' : ''"
       id="codeEl">
							<span class="mdc-notched-outline">
								<span class="mdc-notched-outline__leading"></span>
								<span class="mdc-notched-outline__notch">
									<span class="mdc-floating-label" id="password-message">{{$t('796')}}</span>
								</span>
								<span class="mdc-notched-outline__trailing"></span>
							</span>
							<input class="mdc-text-field__input" type="text"
							aria-labelledby="password-message"
									v-model="code"
									v-validate="'required|alpha_num'"
									ref="code"
									id="code"
									name="code"
									maxlength="50"
								required >
							<i class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing" tabindex="0"
								role="button">report_problem</i>
						</label>
						<div class="mdc-text-field-helper-line d-block">
							<div
								class="mdc-text-field-helper-text mdc-text-field-helper-text--persistent t-helper mdc-text-field-helper-text--validation-msg font-r ">
								{{$t('797')}}
							</div>
						</div>
					</div>
					<div class="mgt-30">
						<button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText dd mgr-8"
							type="submit"  @click="next()" @keypress="next()" tabindex="0">
							<div class="mdc-button__ripple"></div>
							<span class="mdc-button__label t-body2 font-r">{{$t('798')}}</span>
						</button>
						<!-- <button class="mdc-button bg-white t-color-secondaryBtnText  " @click="cancelJoin()">
										<div class="mdc-button__ripple"></div>
										<span class="mdc-button__label t-body2 font-r">{{$t('5')}}</span>
						</button> -->
					</div>
					<div class="mgt-24">
						<div class="d-flex">
							<a class="t-body4 font-r t-color-signBlue" @click="showMessage(1)" @keypress="showMessage(1)" tabindex="0"> {{$t('799')}}</a>
							<div class="t-body4 font-r t-color-signGray pdl-2 pdr-2">{{$t('800')}}</div>
							<a class="t-body4 font-r t-color-signBlue" @click="showMessage(2)" @keypress="showMessage(2)" tabindex="0">{{$t('801')}}</a>
						</div>
					</div>
				</div>
				</form>
			</div>
		</main>
	</div>
	</div>
</template>

<script>
/**
 * 회원가입 - 코드인증 컴포넌트(sign up - auth code component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCTextField} from '@material/textfield'
import {MDCRipple} from '@material/ripple'
import memberApi from '@/api/memberApi.js'
import {mapState, mapMutations} from 'vuex'
import TopAppBar from '@/components/TopAppBar.vue'
import {topAppBarMixin} from '../../mixins/topAppBar.js'
import {joinMixin} from '@/mixins/join.js'
import popupApi from "@/api/popupApi.js";
import loginApi from "@/api/loginApi.js"
import brandApi from "@/api/brandApi.js"
import { commonMixin } from "@/mixins/common.js";
import localStorageUtil from "@/utils/localStorageUtil";
import { userMixin } from "@/mixins/user"

export default {
	data() {
		return {
			code: '',
			codeTextField: null,
			submitState: false,
			validIcon: '',
			popupData: null,
			redirectPath: "",
			memberDutyName: '',
			memberResponsibilityName: '',
			params: "",
			popupImage: null,
			socialFirstName: "",
			socialLastName: "",
			socialFullName: "",
			socialEmail: "",
			socialAuth: false,
			isDrawerOpen: false,
			staticMode: '',
			title: null,
      isIdpService: localStorageUtil.isIdpServiceValidate()
		}
	},

	components: {
		TopAppBar
	},

	watch: {
		'$route' (to, from) {
		   this.setTopAppBarCloseOnly('')
		}
	},

	mixins: [topAppBarMixin,joinMixin,commonMixin,userMixin],

	computed : {
		// code 유효성 Check 및 아이콘(validation code & set icon)
		codeInvalidCheck() {
			let returnValue = false
			if(this.submitState) {
				if (this.errors.has('code')) {
					returnValue = true
					this.validIcon = 'warning'
				} else {
					returnValue = false
					this.validIcon = ''
				}
			}
			this.codeTextField.valid === !returnValue ? '' : this.codeTextField.valid = !returnValue
			return returnValue
		},

	},
	created() {
	  this.title = localStorage.getItem('brandName') || this.$t('794');
	},

	mounted() {
		window.mdc.autoInit();
		const selector = '.mdc-button, .mdc-list, .mdc-list-item, .mdc-card__primary-action, .mdc-chip-set';
		const buttonRipple = [].map.call(document.querySelectorAll(selector), function (el) {
			mdc.ripple.MDCRipple.attachTo(el);
		})
		if(document.querySelector('.mdc-text-field')){
			var textField = new MDCTextField(document.querySelector('.mdc-text-field'));
		}
		this.setMaterialUi()
		//this.$refs.code.focus()
		this.setTopAppBarCloseOnly('')

		this.paramsss = JSON.parse(localStorage.getItem("userParams"));
		memberApi.getMemberInfo().then((response) => {
			let responseData = response.data.data
			this.memberDutyName = responseData.dutyName
			this.memberResponsibilityName = responseData.responsibilityName
		})
	},

	methods: {
		// Store 변이 정의(define store mutation)
		//...mapMutations('join', ['SET_RESPONSIBILITY', 'SET_CODE']),

		...mapMutations("join", [
			"SET_JOINSTART",
			"SET_SOCIAL_LINK",
			"SET_PUSH_NOTIFICATION",
			"SET_NAME_FIRST",
			"SET_NAME_LAST",
			"SET_NAME_FULL",
			"SET_LOGINID",
			"SET_SOCIAL_ID",
			"INIT_JOIN_STORE",
			'SET_RESPONSIBILITY',
			'SET_CODE'
		]),

		...mapMutations("dormancy", ["MUTATION_USER_DATA"]),

		setMaterialUi() {
			this.codeTextField = new MDCTextField(document.querySelector('#codeEl'))
			this.codeTextField.useNativeValidation = false
		},

		login() {
      if (this.isIdpService) {
        this.$moveIdpLogout();
      } else {
        this.$router.push("/login");
      }
		},

		next() {
			this.$validator.validateAll().then((resultValid) => {
				this.submitState = true

				if (resultValid) {
					let params = {
						code: this.code
					}
					// code auth
					memberApi.authResponsibility(params).then((response) => {
						//this.SET_CODE(this.code)
						if(response.data.data === true) {
							this.checkSignInStatus()
						}
					}).catch((err) => {
						// this.$snackOpen({contents:'인증에 실패했습니다. 코드를 확인해주세요.', btnDisplayYN: false}).then(() => {})
						this.$snackOpen({contents: this.$t('1558') + ' ' + this.$t('1559'), btnDisplay:''}).then(() => {})
					})
				}
			})
		},
		checkSignInStatus() {
      let loginAuth = this.isIdpService ? loginApi.authToken() : loginApi.authCheck();
      loginAuth.then((response) => {
				let responseData = response.data.data;
				if (this.isIdpService) {
					loginApi.setAuthInHeader(responseData.token);
				}
				this.MUTATION_USER_DATA(responseData);
				this.checkUser();
				})
				.catch((err) => {
				console.log(err)
				const responseData = err.response.data.meta;

				if (responseData.errCode === 1201) {
					//관리자 승인 대기중(Waiting for administrator approval)
					// 매장 관리자 승인 대기중 입니다. 관리자에게 문의해주세요.
					//this.$snackOpen({contents: 'Todo 관리자 승인 대기중 입니다. 관리자에게 문의해주세요.', btnDisplayYN: false}).then(() => {})

					this.$alert({
					title: this.$t("779"), //가입 승인 대기 상태입니다.
					content:
						this.$t("780") +
						"<br>" +
						this.$t("781", {
						str:
							'<a href="mailto:' +
							BRAND_MANAGER_EMAIL +
							'">' +
							BRAND_MANAGER_EMAIL +
							"</a>",
						}) +
						"<br>" +
						this.$t("782", {
						str:
							'<a href="tel:' +
							BRAND_MANAGER_PHONE +
							'">' +
							BRAND_MANAGER_PHONE +
							"</a>",
						}),
					accept: this.$t("783"),
					})
					.then(() => {})
					.catch(() => {});
				} else if (responseData.errCode === 1202) {
					this.$alert({
					title: this.$t("779"), //가입 승인 대기 상태입니다.
					content:
						this.$t("780") +
						"<br>" +
						this.$t("781", {
						str:
							'<a href="mailto:' +
							BRAND_MANAGER_EMAIL +
							'">' +
							BRAND_MANAGER_EMAIL +
							"</a>",
						}) +
						"<br>" +
						this.$t("782", {
						str:
							'<a href="tel:' +
							BRAND_MANAGER_PHONE +
							'">' +
							BRAND_MANAGER_PHONE +
							"</a>",
						}),
					accept: this.$t("783"),
					})
					.then(() => {})
					.catch(() => {});
				} else if (responseData.errCode === 1204) {
					this.$alert({
					title: this.$t("1482"), //가입 승인 대기 상태입니다.
					content:
						this.$t("1483") +
						"<br>" +
						this.$t("1484") +
						": " +
						'<a href="mailto:' +
						BRAND_MANAGER_EMAIL +
						'">' +
						BRAND_MANAGER_EMAIL +
						"</a>" +
						"<br>" +
						this.$t("1485") +
						": " +
						'<a href="tel:' +
						BRAND_MANAGER_PHONE +
						'">' +
						BRAND_MANAGER_PHONE +
						"</a>",
					accept: this.$t("1486"),
					})
					.then(() => {})
					.catch(() => {});
				} else if (responseData.errCode === 1205) {
					this.$alert({
					title: this.$t("1914"), //가입 승인 대기 상태입니다.
					content:
						this.$t("1915") +
						" " +
						this.$t("1916") +
						"<br>" +
						this.$t("1917", {
						str:
							'<a href="mailto:' +
							BRAND_MANAGER_EMAIL +
							'">' +
							BRAND_MANAGER_EMAIL +
							"</a>",
						}) +
						"<br>" +
						this.$t("1918", {
						str:
							'<a href="tel:' +
							BRAND_MANAGER_PHONE +
							'">' +
							BRAND_MANAGER_PHONE +
							"</a>",
						}),
					accept: this.$t("1919"),
					})
					.then(() => {})
					.catch(() => {});
				} else if (responseData.errCode === 1105) {
					this.$alert({
					content: this.$t("1875"),
					accept: this.$t("1876"),
					})
					.then(() => {})
					.catch(() => {});
				} else if (responseData.errCode === 1335) {
					//아이디 계정 일시 정지(Suspend Account)
					// 로그인 정보가 5회 이상 일치하지 않아 30분간 로그인 정지되었습니다. 30분 후 다시 시도해주세요.
					this.$snackOpen({
					contents: this.$t("323"),
					btnDisplayYN: false,
					}).then(() => {});
				} else {

				}
			});
		},
		signOutFirebase() {
			firebase.auth().signOut();
		},
		setTopAppBarCloseOnly(title) {
			this.leftBtnMode = 'close'
			this.rightBtnMode = ''
			this.title = title || this.title
			this.leftBtnMethod = () => {
				this.login();
			}
			this.rightBtnMethod = ''
		}
	},
}
</script>
